module.exports = __webpack_public_path__ + "static/media/q-mark.e012c629.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/q-mark.svg
// module id = 640
// module chunks = 0